import {createFormActionTypes} from "../../../../shared/ts/helpers/create_form_action_types";
import {createFormActions} from "../../../../shared/ts/helpers/create_form_actions";

const ASSIGN_PROPERTY_FORM = "offer-building-floor/ASSIGN_PROPERTY_FORM";
export const assignPropertyFormTypes = createFormActionTypes(ASSIGN_PROPERTY_FORM);
export const assignPropertyFormActions = createFormActions(assignPropertyFormTypes);
